import React, { AnchorHTMLAttributes } from 'react'
import Link from 'next/link'
import { WithChildren } from '@viveaesthetics/elemy-shared-core'

export interface InternalLinkProps
  extends WithChildren,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string
  'data-test-id'?: string
}

export const InternalLink = ({
  href,
  className,
  children,
  ...rest
}: InternalLinkProps) => {
  return (
    <Link
      href={href}
      data-test-id={rest['data-test-id']}
      rel="noopener noreferrer"
      legacyBehavior
    >
      <a
        className={className}
        data-test-id={rest['data-test-id']}
        target={rest.target || '_self'}
      >
        {children}
      </a>
    </Link>
  )
}
